import React, { useCallback, useEffect, useState } from 'react';
import { AfterPayBanner, AlertsList, EmptyProductsFallback } from '../../components';
import {
    BREADCRUMB,
    GRADPRODUCTTILES,
    HELPBUTTON,
    JWLPAYPALBANNER,
    PAGETITLE,
    PROMOMSG
} from '../../constants/rootElements';
import { PromoCodesProvider, TermsAndConditionsProvider } from '../../context';
import { useFeeAlertInjectionScript, useGoogleAnalyticsHandler } from "../../hooks";
import { appendTermsAndConditionsLink } from '../../util/appendTermsAndConditionsLink';
import { gaPageLoad } from '../../util/googleAnalytics';
import { Breadcrumb } from '../breadcrumb';
import { HelpButton } from '../help';
import { HsGradProductBrowse } from '../hs-grad/gradProductBrowse';
import { TitleBar } from "../productBrowseTitle";

export const ColGradAnncPage = ({ appData }) => {
    const [pbData, setPbData] = useState({})
    const [breadcrumbData, setBreadcrupmData] = useState([])
    const [groupOsr, setGroupOsr] = useState(null)
    const [promoMessages, setPromoMessages] = useState([]);
    const [feeAlertRequestData, setFeeAlertRequestData] = useState(null);
    const [currencyCode] = useState(null);
    const [googleAnalyticsRequestData, setGoogleAnalyticsRequestData] = useState(null);
    const [schoolStoreEvents, setSchoolStoreEvents] = useState([]);

    useFeeAlertInjectionScript(feeAlertRequestData);
    const { selectItemTrackingGASY25, viewModalTrackingGASY25, addToCartTrackingGASY25 } = useGoogleAnalyticsHandler(googleAnalyticsRequestData);

    const gradTitleBar = appData?.pagecontentData?.find(data => data.contentType === "ProductBrowseTitle")
    const gradBreadcrumb = Boolean(appData?.pagecontentData?.find(data => data.contentType === "Navigation"))
    const ProductBrowseProducts = appData?.pagecontentData?.find(data => data.contentType === "ProductBrowseProducts")
    const PaypalBannerData = appData?.pagecontentData?.find(data => data.contentType === "PaypalId")
    const ProductBrowseFlavoredProducts = appData?.pagecontentData?.find(data => data.contentType === "ProductBrowseFlavoredProducts")
    const initialData = { promoCodes: appData.PromoCodesData, excludeList: appData.excludeListData }
    const ProductBrowsePromoMsg = Boolean(
        appData?.pagecontentData?.find(
            (data) => data.contentType === 'ProductBrowsePromoMsg'
        )
    );

    const getBreadcrumb = useCallback(() => {
        BREADCRUMB.render(<Breadcrumb pbData={breadcrumbData} />);
    }, [breadcrumbData])

	const getPromoMsg = useCallback(() => {
        const messagesWithLink = appendTermsAndConditionsLink(promoMessages);
		PROMOMSG.render(<AlertsList messages={messagesWithLink} />);
	}, [promoMessages]);

    const paypalBanner = useCallback(() => {
        JWLPAYPALBANNER.render(<AfterPayBanner currencyCode={currencyCode} />);
    },[PaypalBannerData, currencyCode])

    const productTiles = useCallback(() => {
        const productsData = { ...pbData }
        GRADPRODUCTTILES.render(
            !!productsData?.products?.length
                ? <PromoCodesProvider initialData={initialData}>
                    <TermsAndConditionsProvider>
                        <HsGradProductBrowse
                            pbData={productsData}
                            pageContent={ProductBrowseProducts}
                            filterData={appData.filterData}
                            flavoredProductsPageContent={ProductBrowseFlavoredProducts}
                            fromColGradAnnc={true}
                            groupOsr={groupOsr}
                            schoolStoreEvents={schoolStoreEvents}
                            googleAnalytics={{
                                selectItemTrackingGASY25,
                                viewModalTrackingGASY25,
                                addToCartTrackingGASY25,
                                catalogOSR: googleAnalyticsRequestData?.catalogOsr
                            }}
                        />
                    </TermsAndConditionsProvider>
                </PromoCodesProvider>
                : <EmptyProductsFallback
                    productBrowseData={productsData}
                />
        )
    }, [
        pbData,
        ProductBrowseProducts,
        appData.filterData,
        ProductBrowseFlavoredProducts,
        selectItemTrackingGASY25,
        appData.PromoCodesData
    ])

    const getHelpButton = useCallback(() => {
        HELPBUTTON.render(<HelpButton />);
    }, [])

    const getTitleBar = useCallback(() => {
        PAGETITLE.render(<TitleBar pageContent={gradTitleBar} affiliationData={appData?.affiliationData} />);
    }, [])

    useEffect(() => {
        if (appData.productBrowseData && Object.keys(appData.productBrowseData).length > 0) {
            gaPageLoad();
        }
    }, [])

    useEffect(() => {
        Object.keys(appData.productBrowseData).map((key) => {
            if (key !== "metaData") {
                const catalog = appData.productBrowseData[key];
                catalog && Object.keys(catalog)?.length > 0 &&
                    setPbData(catalog)

                setBreadcrupmData(catalog)
                setPromoMessages(catalog.promoMessagesV2);
                setGroupOsr(catalog.groupOsr);
                const customerNumber = appData.productBrowseData.metaData.customerNumber;
                setFeeAlertRequestData({
                    containerSelector: '#promoMsg',
                    customerId: customerNumber,
                    catalogOsr: catalog.catalogOsr,
                });
                setGoogleAnalyticsRequestData({
                    customerNumber,
                    publishedCatalogId: catalog.publishedCatalogId,
                    sourceCatalogType: catalog.sourceCatalogType,
                    catalogOsr: catalog.catalogOsr
                });
            }
            return true
        })
    }, [appData.productBrowseData])

    return (
        <>
            {gradTitleBar && Object.keys(gradTitleBar)?.length > 0 && getTitleBar()}
            {ProductBrowsePromoMsg && promoMessages?.length > 0 && getPromoMsg()}
            {gradBreadcrumb && getBreadcrumb()}
            {ProductBrowseProducts && Object.keys(ProductBrowseProducts)?.length > 0 && productTiles()}
            {getHelpButton()}
            {PaypalBannerData && Object.keys(PaypalBannerData)?.length > 0 && paypalBanner()}
        </>
    )
}
